import http from 'hub-http/clients/apiClient';
export const deleteInboundRecording = callId => {
  return http.delete(`post-call/v1/voice-recording/${callId}`);
};